export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.notifybear';